import { useCallback, useState } from 'react';

export const useInputTextValidator = (inputText?: string) => {
  const [isValid, setIsValid] = useState(false);

  const valid = useCallback(() => {
    !inputText || /^\s*$/.test(inputText)
      ? setIsValid(false)
      : setIsValid(true);
  }, [inputText]);

  return {
    valid,
    isValid,
  };
};
